var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errorsList.length)?_c('div',[_c('ul',{class:_vm.$style.errorsList},_vm._l((_vm.errorsList),function(error){return _c('li',{key:error.errorType,class:_vm.$style.errorText},[_c('i',{class:[
          'jc-actions-alert',
          _vm.$style.error,
          _vm.$style.errorIcon
        ]}),_c('ScimTestError',{class:_vm.$style.errorMessage,attrs:{"errorObject":error}})],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }